/* eslint-disable linebreak-style */
import React from 'react';

const EquipmentCheckComingsoon = () => (
  <div className="h-100 d-flex align-items-center justify-content-center">
    <div className="coming-soon">
      <h1>
        Scan from CRCE Connect app.
        <span className="dot">.</span>
      </h1>
      <p>Please scan from CRCEC Connect App to check equipment.</p>
    </div>
  </div>
);
export default EquipmentCheckComingsoon;
